import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitCommitAction extends WorkerAction {
  type: GitAction.Commit;
  params: { message: string };
}

export class GitCommitActionError extends WorkerActionError {}

export async function GitCommitActionFn({ lg, util, params }: WorkerFnParams<GitCommitAction>): Promise<void> {
  try {
    const { message } = params;
    lg.callAndCaptureOutput(['commit', '-m', message]);
    await util.syncfs(false);
  } catch (err) {
    throw new GitCommitActionError(err);
  }
}
